export const setTransformData = source => {
    const dataItems = source.items.map(elem => {
        const user = elem?.init_data?.initData?.user;

        return {
            id: elem.id,
            name: user?.firstName ?? null,
            lastName: user?.lastName ?? null,
            username: user?.username ?? null,
            photoUrl: user?.photoUrl ?? null,
            telegramUserId: user?.id ?? null,

            phone: elem.phone ?? null,
            isAllowedPm: elem.is_allowed_pm,
            authDate: elem?.init_data?.initData?.authDate ?? null,
            updatedAt: elem.updated_at,
            createdAt: elem.created_at,

            visitCounter: elem.visit_counter,
            shopId: elem.shop_id,
            personalDataAgreement: elem.personal_data_agreement,
        };
    });

    return {
        items: dataItems,
        total: source?.total,
    };
};
